"use strict";

import Swiper from 'swiper';
import 'bootstrap';
import AOS from 'aos';
import ScrollPlay from './scrollPlay';

window.Swiper = Swiper;
window.AOS = AOS;
window.ScrollPlay = ScrollPlay;

$( document ).ready(function() {
  // AOS
  AOS.init({
    duration: 1200
  });

  // 사이드메뉴
  $(function(){
    var targetControlMenu = $(".container-doc");
    $(".doc-header .btn-menu").on("click", function(){
      targetControlMenu.stop().removeClass("menu-close-animate").addClass("menu-open-animate").addClass("menu-on");
      $("html").addClass("dimmed");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-open-animate");
        }, 1600
      );
    })
  
    $(".menu-side .btn-close").on("click", function(){
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
        }, 1000
      );
    })

    var btnMenu = $(".menu-side .link-main, .menu-side .link-menu")
    btnMenu.on("click", function(){
      var targetUrl = $(this).attr('href');
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
          $(location).attr("href", targetUrl)
        }, 1000
      );
      return false;
    })

    var btnShare = $(".menu-side .btn-share")
    btnShare.on("click", function(){
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
          $('#sns-share').modal();
        }, 1000
      );
    })

    var btnSnsShare = $(".doc-header .btn-sns-share")
    btnSnsShare.on("click", function(){
      $('#sns-share').modal();
      console.log('ss')
    })
  });

  // 서브메뉴
  $(function() {
    var targetSnb = $(".menu-snb");
    var targetHeader = $(".cont-mma .doc-header");
    var classHeaderType = "transparent-visible";
    var topCurrent = $(document).scrollTop();
    // var posSnb = targetSnb.offset().top;
    // var headerHeight = targetHeader.find(".doc-title").innerHeight();
    // var activePos = posSnb - headerHeight;
    var activePos = 52;
    if (topCurrent > activePos) {
      targetSnb.addClass('fix');
      targetHeader.addClass(classHeaderType);
    } else {
      targetSnb.removeClass('fix');
      targetHeader.removeClass(classHeaderType);
    }
    $(window).on('scroll',function() {
      var topCurrent = $(document).scrollTop();
      var opacityTitle = 1 - (topCurrent/activePos);
      var targetTitle = $(".cont-mma .tit-mma, .notice .tit-g");
      if (topCurrent > activePos) {
        targetSnb.addClass('fix');
        targetHeader.addClass(classHeaderType);
      } else {
        targetSnb.removeClass('fix');
        targetHeader.removeClass(classHeaderType);
        targetTitle.css("opacity", opacityTitle);
      }
    });


  });

  // 현재 활성화 된 메뉴로 스크롤 위치 조정
  $(function(){
    var activeListMenu = document.querySelector('.list-menu li.on');
    if(activeListMenu) activeListMenu.scrollIntoView({ block: 'center' });
  })


  // footer
  $(function(){
    // var topPosition = $("#mainContent").offset().top;
    var topPosition = 0;
    $(".doc-footer .btn-top").on("click", function(){
      $("html, body").animate({scrollTop:topPosition}, 500);
    })
  });
    
  // main 알림 버튼 on
  // $(function(){
  //   var alarmBtn = $(".intro-schedule .btn-alarm");
  //   alarmBtn.on('click', function() {
  //     $(this).addClass("on")
  //   })
  // });


  // bottomsheet sort
  $(function() {
    $(".list-sort .btn-sort").on("click", function(){
      $(this).closest("li").siblings().find(".btn-sort").removeClass("on");
      $(this).addClass("on");
    })
  });

  // 공지사항
  $('.notice').on('click','.notice-question',function(e){
		e.preventDefault();
    $(this).next(".notice-answer").slideToggle(100).parents('li').toggleClass('on');
	});

  // 안내
  $(function(){
    $(".box-info-section .btn-more").on("click", function(){
      $(this).closest(".box-info-section").removeClass("overflow");
    })
  });

  $(function(){
    $(window).on('scroll',function() {
      var topCurrent = $(document).scrollTop();
      var topVisual = topCurrent / 3 
      if (topCurrent < 400) {
        $(".info-kv .img-visual").css("margin-top", topVisual + "px");
      }
    });
  });

  //modal header border 추가
  $(function(){
    $(".modal-body").on("scroll", function(){
      $(this).parents(".modal").addClass("scroll");      
      const topModalBody = $(this).scrollTop();
      if (topModalBody == 0) {
        $(".modal").removeClass("scroll")
      }
    }); 
  });

  // marquee
  window.marquee = {
    init: function () {
      var element = $('.marquee');
      var _this = this;
      element.each(function (i) {
        if (_this.isElementOverflowing(element[i])) {
          _this.wrapContentsInMarquee(element[i]);
        }
      });
  
    },
    isElementOverflowing: function (element) {
      var overflowX = element.offsetWidth < element.scrollWidth - 1;
      //console.log(element.offsetWidth, element.scrollWidth -1);
      return (overflowX);
    },
    wrapContentsInMarquee: function (element) {
      var marquee = document.createElement('div'),
          clone = document.createElement('div'),
          contents = element.innerText;
  
      marquee.className = 'origin';
      marquee.innerText = contents;
      clone.className = 'clone';
      clone.innerText = contents;
      element.innerHTML = '';
      element.appendChild(marquee);
      element.appendChild(clone);
      element.className = 'marquee ani';
      var duration = (marquee.offsetWidth)/50+ 's';
      marquee.style.animationDuration = duration;
      clone.style.animationDuration = duration;
    }
  }

  marquee.init();

  
});
